import { render, staticRenderFns } from "./BizTaskNotifyModal.vue?vue&type=template&id=fd194a88&scoped=true&"
import script from "./BizTaskNotifyModal.vue?vue&type=script&lang=js&"
export * from "./BizTaskNotifyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd194a88",
  null
  
)

export default component.exports